/**
* 合同 有关信息
*/
import apis from 'src/const/apis';
import request from 'src/utils/request';
import * as types from 'src/store/types';

const contract = {
  namespaced: true,
  state: {
    dsaShow: false,
    customerId: undefined,
  },
  getters: {

  },
  mutations: {
    [types.SET_CONTRACT_CUSTOMER_ID](state, id) {
      state.customerId = id;
    },
    [types.SET_DSA_DIALOG_SHOWN](state, shown = false) {
      state.dsaShow = shown;
    },
  },

  actions: {
    getDsaAssignInfo({ commit }) {
      return request
        .get(apis.contract.getAssignDsaInfo)
        .then(({ data = {} }) => (data));
    },
    getShownContract({ commit }) {
      return request.get(apis.contract.getShownContract).then(({ data = {} }) => {
        const { pop_ups: popUps = {} } = data;
        if (popUps.is_dsa_show) {
          commit(types.SET_DSA_DIALOG_SHOWN, true);
          commit(types.SET_CONTRACT_CUSTOMER_ID, popUps.customer_id);
        }
      });
    },
    signDsaContact({ commit, state }) {
      return request.post(apis.contract.assignDsa, {
        dsa_sign: true,
        customer_id: state.customerId,
      }).then((res) => {
        commit(types.SET_DSA_DIALOG_SHOWN, false);
        return res;
      }).catch((err) => {
        commit(types.SET_DSA_DIALOG_SHOWN, false);
        return Promise.reject(err);
      });
    },
  },
};

export default contract;
